<template>
    <!-- 机构管理 -->
    <div class="institutionalManagement">
        <div class="search_container">
            <el-form size="mini" ref="institutionalManageData" class="searchBox" :inline="true" :model="insManageData">
                <el-form-item label="机构名称">
                    <el-input v-model="insManageData.orgName" @change="getInsManagementList(1)" clearable placeholder="请输入机构名称"></el-input>
                </el-form-item>
                <el-form-item label="省份" class="mySelect">
                    <el-select v-model="insManageData.provinceId" @change="getInsManagementList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="机构类型" class="mySelect">
                    <el-select v-model="insManageData.orgTypeId" @change="getInsManagementList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in OrgTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button size="mini" type="primary" @click="getInsManagementList(1)">查询</el-button>

        </div>
        <div class="comPractice_container">
            <div class="button_box">
                <el-button type="primary" size="mini" @click="() => {importInsListVisble = true}">批量上传机构</el-button>
                <!-- <el-button type="primary" size="mini" @click="addInsBtn">新增机构</el-button> -->
                <el-button type="primary" size="mini" @click="() => {bathAddInsVisible = true}">新增机构</el-button>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' :tableHeader="institutionalManagement" :tableData="tableData" @operation="operation">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <el-button size="mini" @click="editBtn(data.row)" type="text">编辑</el-button>
                    <el-button size="mini" type="text" @click="deleteBtn(data.row)">删除</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination>
        </div>

        <!-- 添加机构 -->
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addMechanismVisible" class="addMechanismDialog" width="500px" :before-close="AddMechainismhandleClose">
            <div class="dialog_contenter">
                <el-form ref="addmeChanismFormData" :rules="rules" :model="addmeChanismFormData" label-width="100px">
                    <el-form-item label="机构名称:" prop="orgName">
                        <el-input v-model="addmeChanismFormData.orgName" maxlength="50" size="mini" style="width: 200px;" @blur="addmeChanismBlur" placeholder="请输入机构名称"></el-input>
                    </el-form-item>
                    <el-form-item label="省份:" prop="provinceId">
                        <el-select v-model="addmeChanismFormData.provinceId" size="mini" clearable placeholder="请选择省份" style="width: 200px;">
                            <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="机构类型:" prop="orgTypeId">
                        <el-select v-model="addmeChanismFormData.orgTypeId" size="mini" clearable placeholder="请选择机构类型" style="width: 200px;">
                            <el-option v-for="item in OrgTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系人姓名:">
                        <el-input v-model="addmeChanismFormData.person" size="mini" placeholder="请输入机构联系人姓名" style="width: 200px;"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人电话:">
                        <el-input v-model="addmeChanismFormData.phone" @input="value=value.replace(/[^\d.]/gi,'')" size="mini" placeholder="请输入机构联系人电话" style="width: 200px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelBtn">取 消</el-button>
                <el-button size="mini" type="primary" @click="MechanismSaveeBtn">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 批量上传机构 -->
        <basic-dialog :importInsListVisble="importInsListVisble" @changeimportInsListVisble="changeimportInsListVisble" :uploadUrl="uploadUrl" :isApplication="true"></basic-dialog>

        <!-- 批量添加机构 -->
        <el-dialog title="添加机构" :close-on-click-modal="false" :visible.sync="bathAddInsVisible" class="addMechanismDialog" width="65%" :show-close="false" :before-close="() => {bathAddInsVisible = false}">
            <div class="dialog_contenter">
                <div style="display: flex; width: 100%; margin-bottom:10px">
                    <el-select v-model="bathAddData.provinceId"  @change="getInsManagementList(1)" clearable placeholder="所属省份" size="mini" style="width: 150px;margin-right: 10px;">
                        <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="bathAddData.searchContent" size="mini" placeholder="请输入机构名称" clearable style="width: 150px; margin-right: 10px"></el-input>
                    <el-button type="primary" size="mini" @click="() => {getBathAddTableData(1)}">查询</el-button>

                </div>
                <basic-table ref="bathInsTable" v-loading="bathloading" :isCheckbox='true' :tableHeader="bathInsTableHeader" :tableData="bathAddTableData" @operation="bathOperation" :isOperate="false"></basic-table>
                <pagination :total="bathTotal" style="text-align: left; width: 100%;" :limit.sync="pageData.limitSize" :page.sync="pageData.pageNo" @currentChange="bathCurrentChange"></pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="() => {
                    bathAddInsVisible = false
                }">取 消</el-button>
                <el-button size="mini" type="primary" @click="bathAddInsSaveBtn">保 存</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { institutionalManagement, bathInsTableHeader } from './globalData.js'
import fetch from '@/api/fetch.js'
export default {
    name: 'institutionalManagement',

    data() {
        return {
            title: '编辑机构',
            total: 0,
            insManageData: {
                orgName: '',
                orgTypeId: '',
                provinceId: '',
            },
            pageNo: 1,
            limitSize: 10,
            loading: false,
            addmeChanismFormData: {
                orgName: '',
                provinceId: '',
                orgTypeId: '',
                person: '',
                phone: ''
            },
            provinceData: [],
            institutionalManagement: institutionalManagement,

            OrgTypeList: [], // 机构类型列表
            addMechanismVisible: false,
            rowData: {},
            rules: {
                orgName: [{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }, { required: true, message: '请输入机构名称', trigger: 'blur' }],
                provinceId: { required: true, message: '省份不能为空', trigger: 'blur' },
                orgTypeId: { required: true, message: '机构类型不能为空', trigger: 'blur' }
            },
            isOrgName: true,
            currentTimeout: null,

            bathAddInsVisible: false, // 批量添加
            tableData: [],
            bathInsTableHeader: bathInsTableHeader,
            bathAddTableData: [],
            bathloading: false,
            pageData: {
                pageNo: 1,
                limitSize: 10
            },
            bathTotal: 10,
            bathAddData: {
                provinceId: '',
                searchContent: ''
            },
            bathInsRowData: [],

            importInsListVisble: false, // 导入机构
            uploadUrl: 'https://zledu-sx.oss-cn-beijing.aliyuncs.com/cjdd/matchSignup/template/批量导入机构模板.xlsx'
        };
    },
    watch: {
        bathAddInsVisible: {
            handler(newVal) {
                if (newVal) {
                    this.getBathAddTableData(1)
                } else {
                    this.$refs.bathInsTable.$refs.basicTable.$parent.getClearSelect()
                    this.bathAddData = {
                        provinceId: '',
                        searchContent: ''
                    }
                    this.pageData =  {
                        pageNo: 1,
                        limitSize: 10
                    }
                    this.bathInsRowData = []
                    this.getInsManagementList(1)
                }
            }
        }
    },

    mounted() {
        this.getOrgTypeListUrl()
        this.getProvinceList()
        this.getInsManagementList()
    },
    methods: {
        bathAddInsSaveBtn() {
            fetch.saveBathIns({orgList: this.bathInsRowData}).then(res => {
                if(res.code == '0') {
                    this.bathAddInsVisible = false
                    this.$message.success(res.msg)
                } else {
                    this.$message.error(res.msg)
                }
            })
         },
        bathCurrentChange(val) {
            this.pageData.limitSize = val.limit
            this.pageData.pageNo = val.page
            this.currentTimeout = setTimeout(() => {
                this.getBathAddTableData(this.pageData.pageNo)
            }, 40)
        },
        bathOperation(val, rowData) {
            if(val == 'selectChange') {
                this.bathInsRowData = rowData
            }
        },
        getBathAddTableData(page) {
            this.bathloading = true
            fetch.addOrgList({
                ...this.bathAddData,
                pageNo: page ? page : this.pageData.pageNo, limitSize: this.pageData.limitSize
            }).then(res => {
                if (res.code == '0') {
                    this.bathloading = false
                    this.bathAddTableData = res.data.records
                    this.pageData.pageNo = res.data.current
                    this.pageData.limitSize = res.data.size
                    this.bathTotal = res.data.total

                } else {
                    this.bathloading = false
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.bathloading = false
            })
        },
        deleteBtn(rowData) {
            fetch.deleteOrg({ id: rowData.id }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getInsManagementList(1)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        changeimportInsListVisble(val) {
            this.importInsListVisble = val
        },
        cancelBtn() {
            this.addMechanismVisible = false
            this.addmeChanismFormData = {
                orgName: '',
                provinceId: '',
                orgTypeId: '',
                person: '',
                phone: ''
            }
        },
        async getProvinceList() { // 获取省份
            const res = await fetch.getProvinceList()
            if (res.code == '0') {
                this.provinceData = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        MechanismSaveeBtn() { // 新增机构保存
            this.$refs.addmeChanismFormData.validate((valid) => {
                if (valid) {
                    if (this.isOrgName) {
                        fetch.updateDictOrg({ id: this.rowData.id, ...this.addmeChanismFormData }).then(res => {
                            if (res.code == '0') {
                                this.$message.success(res.msg)
                                this.addMechanismVisible = false
                                this.getInsManagementList()
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    } else {
                        this.$message.error('机构名称重复,请进行更换')
                    }
                } else {
                    return false;
                }
            })
        },
        editBtn(rowData) {
            this.rowData = rowData
            this.title = '编辑机构'
            this.addMechanismVisible = true
            this.addmeChanismFormData.orgName = rowData.orgName
            this.addmeChanismFormData.provinceId = rowData.provinceId
            this.addmeChanismFormData.orgTypeId = rowData.orgTypeId
            this.addmeChanismFormData.person = rowData.person
            this.addmeChanismFormData.phone = rowData.phone
        },
        addmeChanismBlur() { // 校验机构名称是否重复
            fetch.checkOrgName({ id: this.rowData.id, orgName: this.addmeChanismFormData.orgName }).then(res => {
                if (res.code == '0') {
                    if (res.data == false) {
                        this.$message.error('已存在该机构名称, 请更换其他名字')

                    } else {
                        this.isOrgName = false
                    }
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        getInsManagementList(page) {// 初始化
            this.loading = true
            fetch.getDictOrgListPage({ ...this.insManageData, pageNo: page || this.pageNo, limitSize: this.limitSize }).then(res => {
                if (res.code == '0') {
                    this.loading = false
                    this.tableData = res.data.records
                    this.total = res.data.total
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                } else {
                    this.loading = false
                    this.$message.error(res.msg)
                }
            })
        },
        getOrgTypeListUrl() {
            fetch.getOrgTypeListUrl().then(res => {
                if (res.code == '0') {
                    this.OrgTypeList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        AddMechainismhandleClose() {
            this.addMechanismVisible = false
            this.addmeChanismFormData = {
                orgName: '',
                provinceId: '',
                orgTypeId: '',
                person: '',
                phone: ''
            }
        },
        currentChange(val) {
            this.limitSize = val.limit
            this.pageNo = val.page
            this.currentTimeout = setTimeout(() => {
                this.getInsManagementList(this.pageNo)
            }, 40)
        },
        addInsBtn() { // 新增机构
            this.addMechanismVisible = true
            this.title = '添加机构'
        },
        operation() {

        }
    },
    beforeDestroy() {
        clearTimeout(this.currentTimeout)
        this.currentTimeout = null
    },
    components: {
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue'),
        basicDialog: () => import('@/components/basicDialog.vue')
    }
};
</script>

<style lang="scss" scoped>
.institutionalManagement {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .searchBox_left {
            margin-right: 20px;
        }
        .searchBox_right {
            margin-right: 20px;
        }
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }
    .dialog_contenter {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .addMechanismDialog {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    .basicTable {
        margin-top: 10px;
        height: 350px;
    }
}
</style>